import { schema } from "normalizr";

export const backupsSchema = new schema.Entity(
  "backups",
  {},
  { idAttribute: "backupId" },
);

export const backupsListSchema = [backupsSchema];
